import React from 'react';
// import { Timesheet } from '../../Components/time_expense_sheets/Timesheet';
// import { Footer } from '../../Components/footer/Footer';

export function TimeAndExpense() {
  return (
    <section className="container py-5">
      <h1>TimeAndExpense</h1>
      <div className="d-flex justify-content-center">{/* <Timesheet/> */}</div>

      {/* <Footer/> */}
    </section>
  );
}
